<template>
	<div v-if="serverBusy" id="server-activity">
		<span class="loading-icon"></span>
		<span class="loading-message">{{ busyText }}</span>
	</div>
	<div class="table-container" v-if="!isMobile">
		<table class="buyIn-list">
			<tr class="sticky">
				<th>Admin Name</th>
				<th>Buy-In Name</th>
				<th>Priority</th>
				<th>Start Date</th>
				<th>End Date</th>
				<th>Min Buy</th>
				<th>Max Buy</th>
				<th>
					Regular Credit Per
					{{
						systemCurrencyTool.formatFromFractionalAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit,
							0
						)
					}}
				</th>
				<th>
					Promo Credit Per
					{{
						systemCurrencyTool.formatFromFractionalAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit,
							0
						)
					}}
				</th>
				<th>Cashier</th>
				<th>MRU</th>
				<th>Web</th>
				<th>Edit</th>
				<th>Delete</th>
				<!-- <th>Edit</th> -->
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired || buyIn.status == 'Hidden' ? 'expired' : ''" v-for="(buyIn, index) in buyIns" :key="index" :value="buyIn.id">
				<td>{{ buyIn.adminName }}</td>
				<td>{{ buyIn.publicName }}
					<span v-if="buyIn.status == 'Hidden'" class="expired-text">HIDDEN</span>
				</td>
				<td class="center">{{ buyIn.priority }}</td>
				<td>{{adjustDateForTimeZoneOffset(new Date(buyIn.startDate)) }}</td>
				<td>
					{{adjustDateForTimeZoneOffset(new Date(buyIn.endDate))}}
					<span v-if="buyIn.isExpired" class="expired-text">EXPIRED</span>
				</td>
				<td class="cash">{{ systemCurrencyTool.formatCurrency(buyIn.minimumCOC, systemFull) }}</td>
				<td class="cash">{{ systemCurrencyTool.formatCurrency(buyIn.maximumCOC, systemFull) }}</td>
				<td class="cash">{{ systemCurrencyTool.formatFromFractionalAU(buyIn.creditRegularAUPerCashCOC, 0) }}</td>
				<td class="cash">{{ systemCurrencyTool.formatFromFractionalAU(buyIn.creditPromoAUPerCashCOC, 0) }}</td>
				<td class="check-status" :title="buyIn.cashierAllowed ? 'Cashier Allowed' : 'Cashier Not Allowed'">
					{{ buyIn.cashierAllowed ? "✅" : "🚫" }}
				</td>
				<td class="check-status" :title="buyIn.mruAllowed ? 'MRU Allowed' : 'MRU Not Allowed'">{{ buyIn.mruAllowed ? "✅" : "🚫" }}</td>
				<td class="check-status" :title="buyIn.webAllowed ? 'Web Allowed' : 'Web Not Allowed'">{{ buyIn.webAllowed ? "✅" : "🚫" }}</td>
				<td class="check-status" :class="buyIn.isObsolete ? 'obsolete' : 'active'" :title="buyIn.isObsolete ? 'Obsolete' : 'Active'">
					<button class="btn" v-if="!buyIn.isObsolete" title="Click to edit the offer." @click="showEditOffer(buyIn)">
						Edit Offer
					</button>
				</td>
				<td class="check-status" :class="buyIn.isObsolete ? 'obsolete' : 'active'" :title="buyIn.isObsolete ? 'Obsolete' : 'Active'">
					<button class="btn" v-if="!buyIn.hasTransactions" title="Click to delete the offer." @click="showDeleteOfferModal(buyIn)">
						Delete Offer
					</button>
				</td>
				<!-- <td>
					<button class="btn" title="Click to edit the offer" @click="showEditOffer(buyIn)">
						Edit Offer
					</button>
				</td> -->
			</tr>
		</table>
	</div>
	<div class="table-container" v-if="isMobile">
		<table class="buyIn-list" style="margin-bottom: 15px;"  v-for="(buyIn, index) in buyIns" :key="index" :value="buyIn.id">
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Admin Name</th>
				<td>{{ buyIn.adminName }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Buy-In Name</th>
				<td>{{ buyIn.publicName }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Priority</th>
				<td>{{ buyIn.priority }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Start Date</th>
				<td>{{adjustDateForTimeZoneOffset(new Date(buyIn.startDate)) }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>End Date</th>
				<td>{{adjustDateForTimeZoneOffset(new Date(buyIn.endDate))}}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Min Buy</th>
				<td>{{ systemCurrencyTool.formatCurrency(buyIn.minimumCOC, systemFull) }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Max Buy</th>
				<td>{{ systemCurrencyTool.formatCurrency(buyIn.maximumCOC, systemFull) }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Regular Credit Per
					{{
						systemCurrencyTool.formatFromFractionalAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit,
							0
						)
					}}</th>
				<td>{{ systemCurrencyTool.formatFromFractionalAU(buyIn.creditRegularAUPerCashCOC, 0) }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Promo Credit Per
					{{
						systemCurrencyTool.formatFromFractionalAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit,
							0
						)
					}}</th>
				<td>{{ systemCurrencyTool.formatFromFractionalAU(buyIn.creditPromoAUPerCashCOC, 0) }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Cashier</th>
				<td>{{ buyIn.cashierAllowed ? "✅" : "🚫" }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>MRU</th>
				<td>{{ buyIn.mruAllowed ? "✅" : "🚫" }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Web</th>
				<td>{{ buyIn.webAllowed ? "✅" : "🚫" }}</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Edit</th>
				<td><button class="btn" v-if="!buyIn.isObsolete" title="Click to edit the offer." @click="showEditOffer(buyIn)">
						Edit Offer
					</button>
				</td>
			</tr>
			<tr class="buyIn-row" :class="buyIn.isExpired ? 'expired' : ''">
				<th>Delete</th>
				<td><button class="btn" v-if="!buyIn.hasTransactions" title="Click to delete the offer." @click="showDeleteOfferModal(buyIn)">
						Delete Offer
					</button>
				</td>
			</tr>
			
		</table>
	</div>
	<dialog id="obsolesce-dialog">
		<div>
			<p id="dialog-text">
				{{`Are you sure you want to set ${this.buyIn?.name} to obsolete?` }}
			</p>
			<div id="btn-container">
				<button id="confirmButton" class="btn" value="default" @click="setBuyInObsolete(this.buyIn)">Ok</button>
				<button id="cancelButton" class="btn" value="cancel" formmethod="dialog" @click="closeModal()">Cancel</button>
			</div>
		</div>
	</dialog>
	<transition name="fade">
		<component :is="currentModal" :buyIn="buyIn" :systemCurrencyTool="systemCurrencyTool" :casinoList="casinoList" :adminState="adminState" :isMobile="isMobile"/>
	</transition>
</template>

<script>
import sharedScripts from "@/dependencies/sharedScripts";
import EditBuyIn from "./EditBuyIn.vue";
import router from "@/router/index";
import DeleteBuyInModal from "./DeleteBuyInModal.vue";

export default {
	name: "BuyInsTable",
	components: {
		EditBuyIn,
		DeleteBuyInModal
	},
	props: {
		buyIns: Array,
		adminState: Object,
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		casinoList: Object,
		isMobile: Boolean
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			systemMinorWholeOrFull: this.systemCurrencyTool.displayType.minorWholeOrFull,
			inGameMinorWholeOrFull: this.inGameCurrencyTool.displayType.minorWholeOrFull,
			systemFull: this.systemCurrencyTool.displayType.full,
			serverBusy: false,
			busyText: "",
			inputDialog: null,
			buyIn: null,
			currentModal: null,
		};
	},
	created() {
		this.eventBus.on("closeEditOfferModal", () => {
			this.currentModal = null;
			this.eventBus.emit("updateBuyInList");
		});
		this.eventBus.on("closeDeleteBuyInModal", () =>{
			this.currentModal = null;
		});
		this.eventBus.on("deleteBuyInOffer", () => {
			this.currentModal = null;
			this.deleteBuyInOffer();
		})
	},
	mounted() {
		this.inputDialog = document.getElementById("obsolesce-dialog");
	},
	methods: {
		async setBuyInObsolete(buyIn) {
			if (buyIn.isObsolete) return;
			
			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				this.busyText = "";
				return false;
			}

			this.busyText = `Setting ${buyIn.name} to obsolete.`;
			this.serverBusy = true;
			this.status.ok = true;

			let requestUrl = new URL(`/api/v1/offer/${buyIn.id}/make-obsolete`, this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				headers: headerObj,
			});

			try {
				let response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response);

				if (fetchStatus && !fetchStatus.ok) {
					this.serverBusy = false;
					this.busyText = "";
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout) this.eventBus.emit("forceLogout");
					return false;
				}

				let dataJson = await response.json();

				this.status.message = `${dataJson.name} is now obsolete.`;
				this.status.code = fetchStatus.code;
				this.status.ok = fetchStatus.ok;
				this.eventBus.emit("updateStatus", this.status);

				this.eventBus.emit("updateBuyInList");
				this.closeModal();

				this.serverBusy = false;
				this.busyText = "";
				this.closeModal();
			} catch (e) {
				this.status.code = e;
				this.status.ok = false;
				this.userMustDismiss = true;
				this.eventBus.emit("updateStatus", this.status);
				this.closeModal();
				console.error(e);
				this.closeModal();
				return false;
			}
		},

		showDeleteOfferModal(buyIn) {
			this.buyIn = buyIn;
			this.currentModal = "DeleteBuyInModal";
		},

		async deleteBuyInOffer() {

			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				this.busyText = "";
				return false;
			}

			this.busyText = "Saving";
			this.serverBusy = true;
			this.status.ok = true;
			
			let body = {
				BuyInOfferId: this.buyIn.id,
			};

			let requestUrl = new URL("/api/v1/offer/delete/", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

            try{
                let response = await fetch(request);

                let fetchStatus = sharedScripts.checkFetchErrors(response);

                if(fetchStatus && !fetchStatus.ok){
                    this.serverBusy = false;
                    this.busyText = "";
                    this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout) this.eventBus.emit("forceLogout");
                    return false;
                }

				this.serverBusy = false;
                this.status.message = `${this.buyIn.publicName} has been Deleted.`;
                this.status.code = fetchStatus.code;
                this.status.ok = fetchStatus.ok;
                this.eventBus.emit("updateStatus", this.status);
                this.eventBus.emit("updateBuyInList");
            }
            catch(e) {
                console.log("this is the error", e);
				this.serverBusy = false;
                this.status.code = e;
                this.status.ok = false;
                this.eventBus.emit("updateStatus", this.status);
                return false;
            }
		},

		showObsolesceDialog(buyIn) {
			this.buyIn = buyIn;
			this.inputDialog.showModal();
		},

		showEditOffer(buyIn) {
			this.buyIn = buyIn;
			this.currentModal = "EditBuyIn";
		},

		closeModal() {
			this.inputDialog.close();
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#server-activity {
	position: absolute;
	width: 100%;
	height: 100%;
	background: rgb(0 0 0 / 70%);
	backdrop-filter: blur(6px);
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	display: grid;
	align-content: center;
	z-index: 2;
}

.table-container {
	padding-bottom: 15px;
}

.sticky {
	top: -15px;
}

.buyIn-list {
	width: 100%;
	text-align: left;
	border-collapse: collapse;
}

.buyIn-list td {
	border: 1px #000 solid;
}

.buyIn-list th,
.buyIn-list td {
	padding: 5px 10px;
}

.details {
	overflow-wrap: anywhere;
}

.buyIn-row {
	color: #000;
	background-color: #9b9b9b;
}

.buyIn-list tr:nth-child(2n) {
	background-color: #bfbfbf;
}

.buyIn-row {
	/* cursor: pointer; */
	transition: background-color 0.5s ease, color 0.5s ease;
}

tr.buyIn-row:hover {
	background-color: #5b88bf;
	color: white;
}

.check-status {
	text-align: center;
	font-weight: bold;
	cursor: help;
}

.active {
	cursor: pointer;
}

.buyIn-row.expired {
	background-color: #3f3f3f !important;
	color: #808080;
}

.expired-text {
	color: #f00;
	font-weight: bold;
}

.cash {
	white-space: pre;
	text-align: right;
}

.center {
	text-align: center;
}
#obsolesce-dialog {
	margin: auto;
	background-color: #000;
	color: #fff;
	border-radius: 12px;
	border-width: 1px;
}
::backdrop {
	background-color: #000;
	backdrop-filter: blur(8px);
	opacity: 0.75;
}

#btn-container {
	display: flex;
	justify-content: center;

	.btn {
		min-width: 6em;
		min-height: 2.3em;
	}
	
}

#obsolesce-dialog {
		margin: auto;
}

#dialog-text {
	text-align: center;
}
</style>
